export default __webpack_public_path__ + "static/media/error.248f2f89.svg";